import { faCircleCheck, faCircleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StatusCode } from "api/protocols";
import { GetTeeSheetAuditTrails } from "api/rpc/2024-04/facilityAdmin/teesheet/teeSheet";
import Sheet from "components/sheet/Sheet";
import Portal from "elements/Portal";
import React, { useEffect } from "react";
import { showError } from "redux/actions/ui";
import "./teeSheetAuditTrailModal.scss";
import "components/bookingPopUp/auditTrailNote/AuditTrailNote.scss";
import moment from "moment";
import { ICustomer } from "redux/reducers/models/customer";

export interface ITeeSheetAuditTrail {
  id: number;
  teeSheetId: number;
  title: string; // Title of the action performed
  action: string;
  created_at: string; // ISO date string
  description?: string; // Additional details about the action
  user_id: ICustomer; // ID of the user who performed the action
}

export interface ITeeSheetAuditTrailModalProps {
  state: { isOpen: boolean; teeSheetId: number; date: Date };
  update: (newState: ITeeSheetAuditTrail) => void;
  close: () => void;
  onOk: () => void;
}

export default function TeeSheetAuditTrailModal(props: ITeeSheetAuditTrailModalProps) {
  const { state, close } = props;

  const [auditTrail, setAuditTrail] = React.useState<ITeeSheetAuditTrail[]>([]);

  useEffect(() => {
    if (state.isOpen) {
      void fetchAuditTrail();
    }
  }, [state.isOpen === true]);

  async function fetchAuditTrail() {
    setAuditTrail([]);

    const res = await GetTeeSheetAuditTrails(
      {
        template_id: state.teeSheetId,
        date: moment(state.date).format("YYYY-MM-DD"),
      },
      true,
    );

    if (res.status !== StatusCode.OK) {
      showError("Failed to fetch audit trail");
      return;
    }

    setAuditTrail(res.data as ITeeSheetAuditTrail[]);
  }

  return (
    <Portal isMounted={state.isOpen}>
      <Sheet
        open={state.isOpen}
        title={"Tee Sheet Audit Trail"} // TODO: Translation
        size="small"
        hideCancelButton
        closable
        onCancel={close}
      >
        <div>
          {auditTrail.length === 0 ? (
            <div style={{ marginBottom: "16px" }}>
              Audit
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100px",
                }}
              >
                <div style={{ fontWeight: "bold" }}>No Activity Yet</div>
                <div style={{ color: "#888", fontSize: "14px" }}>
                  Once changes are made to this tee sheet, they will{" "}
                </div>
                <div style={{ color: "#888", fontSize: "14px", marginBottom: "10px" }}>
                  appear here for your review.
                </div>
                {/* <ButtonNew
                  type="primary"
                  onClick={() => {
                    history.push("settings/tee-sheet/calendar");
                  }}
                >
                  Create Tee Sheet
                </ButtonNew> */}
              </div>
            </div>
          ) : (
            <ul>
              Audit
              {auditTrail.map((audit, index) => (
                <>
                  <li key={audit.id}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                      <div className="audit-trail-note-container">
                        <div style={{ justifySelf: "center" }}>
                          <div className={`audit-trail-circle-${audit.action}`}>
                            {audit.action === "modified" ? (
                              <FontAwesomeIcon
                                icon={faCircleExclamation}
                                className={`audit-trail-circle-${audit.action}-icon`}
                              />
                            ) : (
                              <FontAwesomeIcon
                                icon={faCircleCheck}
                                className={`audit-trail-circle-${audit.action}-icon`}
                              />
                            )}
                          </div>
                          {index < auditTrail.length - 1 ? <div className="bm-audit-trail-line"></div> : null}
                        </div>
                        <div style={{ marginLeft: "18px" }}>
                          <div className="audit-trail-title">{audit.title}</div>
                          <div className="audit-trail-note">{audit.description}</div>
                        </div>
                      </div>
                      <div className="audit-trail-date">
                        <div>{moment(audit.created_at).format("MMMM Do YYYY, h:mm a")}</div>
                        <div>{audit.user_id?.full_name}</div>
                      </div>
                    </div>
                  </li>
                </>
              ))}
            </ul>
          )}
        </div>
      </Sheet>
    </Portal>
  );
}
